import { SVGProps } from 'react'

const Stakedao = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    style={{
      width: '1em',
      height: '1em',
      fill: 'currentColor',
    }}
    viewBox="0 0 64 54"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m13.373 34.47.955 6.704-4.776.957-3.82-.957L0 31.599l1.91-17.236 6.687-8.618 8.597-.957L25.79 0l11.464 5.745-2.866 2.873c8.278 1.276 13.692 2.234 16.239 2.873 3.82.957 10.508 5.745 11.462 6.702.956.958.5 5.359 0 8.618-.333 2.172-.97 3.768-1.91 4.788L64 53.622h-8.597l1.91-1.915-7.641-16.279-21.016 2.873-7.64 15.32H12.42l2.865-4.787 5.731-20.108-3.82-3.83-8.6 1.915-.955 7.66 2.865 2.873 2.867-2.873Zm13.438 11.31 2.854-5.881 3.805-.98 2.854 14.703h-9.513l1.902-.98-1.902-6.862Zm18.335-6.658L48 37.19l4.757 8.216-.952 8.217h-8.562l1.903-2.9v-11.6Z"
      clipRule="evenodd"
    />
  </svg>
)
export default Stakedao
